/* global axios */

// [xleaders] Panel CRM nằm ngoài /api/v1 vì nó phục vụ cả iframe Dashboard App (xem
// config/routes.rb block `# [xleaders]`), nên không dùng ApiClient được — gọi thẳng axios.
// window.axios đã gắn sẵn header devise_token_auth cho MỌI request nên không cần tự thêm.
//
// `conversationDisplayId`: `conversation.id` phía frontend LÀ display_id, không phải khoá chính
// (app/views/api/v1/models/_conversation.json.jbuilder). Controller tra đúng bằng display_id.
export default {
  // CHỈ ĐỌC — cố ý không dùng `/state`: action đó backfill phone/email vào contact và tốn thêm một
  // request `person`, mà mục sidebar này chạy mỗi lần sale mở một hội thoại.
  consultationLog(accountId, conversationDisplayId) {
    return axios.get('/xleaders/crm_panel/consultation_log', {
      params: {
        account_id: accountId,
        conversation_display_id: conversationDisplayId,
      },
    });
  },

  classes(accountId, conversationDisplayId, opportunityIds) {
    return axios.get('/xleaders/crm_panel/classes', {
      params: {
        account_id: accountId,
        conversation_display_id: conversationDisplayId,
        opportunity_ids: opportunityIds.join(','),
      },
    });
  },
};
